import basketDraftStoreCreator from 'store/basketDraft.store';

const useBasketDraftList = basketDraftStoreCreator();

export default useBasketDraftList;
